<template>
  <v-form ref="addEditSubEventDetailsForm" v-model="isValid">
    <v-row class="pa-3">
      <v-col cols="12" md="12">
        <div class="text-subtitle-1 font-weight-bold">Sub-event details</div>
      </v-col>

      <!--Start: Upload image--->
      <v-col cols="12" md="12" class="ml-1" v-if="!isTravelEvent">
        <AddNewImage
          v-if="currentSubEvent.coverImageURL == '' "
          :applyDashedBorder="true"
          :isRectangle="true"
          :width="510.3"
          :height="337.5"
          text="Upload cover image"
          @click="showUploadCoverImageDialog = true"
          color="white"
        />
        <v-hover v-slot="{ hover }" v-else>
          <v-sheet width="567" height="375">
            <v-img
              width="567"
              height="375"
              class="rounded-lg outlined-border"
              :src="currentSubEvent.coverImageURL"
            >
              <div class="text-right mt-2 mr-2" v-show="hover">
                <AvatarButton
                  icon="mdi-image"
                  tooltipText="Change image"
                  @click="showUploadCoverImageDialog = true"
                  className="d-inline-block mr-2"
                />

                <AvatarButton
                  icon="mdi-trash-can"
                  tooltipText="Delete image"
                  @click="currentSubEvent.coverImageURL = ''"
                  className="d-inline-block"
                />
              </div>
            </v-img>
          </v-sheet>
        </v-hover>

        <UploadImageDialog
          :show="showUploadCoverImageDialog"
          isDisplayImage
          previewType="rectangle"
          ref="uploadCoverImageDialog"
          @close="showUploadCoverImageDialog = false"
          @uploaded="handleCoverImageUploaded"
          :uploadToBusinessProfile="false"
          :generateCompressedImage="true"
          @compressed-image-uploaded="handleCompressedImageUploaded"
        />
      </v-col>
      <!--End: Upload image--->

      <!-- <UploadImages eventCategory="subEvent" /> -->

      <!--Start: Sub event format--->
      <v-col cols="12" md="12" v-if="!isTravelEvent">
        <div class="text-body-2 font-weight-medium">Sub-event format</div>
      </v-col>
      <v-col cols="12" class="pt-0" v-if="!isTravelEvent">
        <v-radio-group v-model="currentSubEvent.type" row class="mt-0">
          <v-radio
            value="online"
            label="Online"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >Online</v-radio
          >
          <v-radio
            value="in-person"
            label="In-person"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >In-person</v-radio
          >
          <v-radio
            value="hybrid"
            label="Hybrid"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >Hybrid</v-radio
          >
        </v-radio-group>
      </v-col>
      <!--End: Sub event format--->

      <!---Start: Sub event details--->

      <v-col cols="12" md="12" class="pt-0">
        <div class="text-body-2 font-weight-medium">Sub-event name</div>
      </v-col>
      <v-col cols="12" md="7" class="py-0">
        <v-text-field
          dense
          outlined
          placeholder="eg: Melbourne Start-up Annual Pitch Night"
          v-model="currentSubEvent.name"
          :rules="requiredRules"
        />
      </v-col>
      <v-col cols="12" md="12" class="pt-0">
        <v-row dense>
          <v-col cols="6" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">Timezone</div>
          </v-col>

          <v-col cols="12" md="7" class="py-0">
            <v-autocomplete
              v-model="currentSubEvent.timezone"
              :items="timezoneItems"
              outlined
              :rules="requiredRules"
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">Date{{ !isTravelEvent ? " and Time" : "" }}</div>
          </v-col>
          <!-- <v-col cols="12" md="12">
            <v-alert
              text
              width="50%"
              color="primary"
              dense
              v-if="isDateTimePickerReadOnly"
            >
              <div class="d-flex justif-center align-center">
                <v-icon color="primary" class="mr-2">mdi-alert-circle</v-icon>
                <div>{{ alertText }}</div>
              </div>
            </v-alert>
          </v-col> -->
          <v-col cols="7" class="py-0">
            <vc-date-picker  v-if="isTravelEvent"
              v-model="range"
              mode="date"
              :is-range="false"
              :minDate="minStartDate"
              @input="handleBlur"
              is-required
              :select-attribute="attribute"
              :drag-attribute="attribute"
              :input-debounce="20000"
              :popover="{ placement: 'top', visibility: 'click' }"
              :timezone="currentSubEvent.timezone"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <v-text-field
                  :value="getEventDateTime(inputValue)"
                  v-on="inputEvents"
                  outlined
                  dense
                  :disabled="isDateTimePickerReadOnly"
                  :readonly="true"
                  validate-on-blur
                  :rules="requiredRules"
                  @change.native="inputEvents.updateValue($event.target.value)"
                  placeholder="Select Date"
                />
              </template>
            </vc-date-picker>
            <vc-date-picker
                v-else
              v-model="range"
              mode="dateTime"
              :is-range="isTravelEvent ? false: true"
              :minDate="minStartDate"
              @input="handleBlur"
              is-required
              :select-attribute="attribute"
              :drag-attribute="attribute"
              :input-debounce="20000"
              :popover="{ placement: 'top', visibility: 'click' }"
              :timezone="currentSubEvent.timezone"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <v-text-field
                  :value="getEventDateTime(inputValue)"
                  v-on="inputEvents.start"
                  outlined
                  dense
                  :disabled="isDateTimePickerReadOnly"
                  :readonly="true"
                  validate-on-blur
                  :rules="requiredRules"
                  @change.native="inputEvents.updateValue($event.target.value)"
                  placeholder="Select date and time"
              />
            </template>
          </vc-date-picker>
          </v-col>
          <v-col cols="7" class="pb-8" v-if="isTravelEvent">
            <v-row>
            <v-col cols="6" class="pb-0">
              <vc-date-picker
                mode="time"
                @input="onTimeUpdate(false)"
                v-model="timeRange.start"
                :maxDate="timeRange.end"
                :timezone="currentSubEvent.timezone"
                :popover="{ placement: 'top', visibility: 'click' }"
              >
              <template v-slot="{inputValue, inputEvents}">
                <v-col class="px-0 py-0 d-flex align-center justify-space-between" cols="12" md="12">
                  <div class="text-body-2 font-weight-medium">
                    Start Time
                  </div>
                  <v-switch @change="onStartTimeSwitch" class="align-start" v-model="currentSubEvent.enableStartTime"> </v-switch>
                </v-col>
              <v-text-field v-if="currentSubEvent.enableStartTime"
                  :value="getEventTime(inputValue, false)"
                  v-on="inputEvents"
                  readonly
                  outlined dense validate-on-blur placeholder="Start Time"/>
              </template>
              </vc-date-picker>

            </v-col>
              <v-col cols="6" class="pb-0">
                <vc-date-picker
                    mode="time"
                    @input="onTimeUpdate(true)"
                    v-model="timeRange.end"
                    :minDate="timeRange.start"
                    :timezone="currentSubEvent.timezone"
                    :popover="{ placement: 'top', visibility: 'click' }"
                >
                  <template v-slot="{inputValue, inputEvents}">
                    <v-col class="px-0 py-0 d-flex align-center justify-space-between" cols="12" md="12">
                      <div class="text-body-2 font-weight-medium">
                        End Time
                      </div>
                      <v-switch @change="onEndTimeSwitch" class="align-start" v-model="currentSubEvent.enableEndTime" :disabled="!currentSubEvent.enableStartTime"> </v-switch>
                    </v-col>
                    <v-text-field
                        :value="getEventTime(inputValue, true)"
                        v-if="currentSubEvent.enableEndTime"
                        v-on="inputEvents"
                        readonly
                        outlined dense validate-on-blur placeholder="End Time"/>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" md="6" class="my-0 py-0">
          <div v-if="currentSubEvent.startDateTime != null">
            {{ getEventActivationAndExpirationDateTime() }}
          </div>
        </v-col> -->

          <v-col
            cols="7"
            md="12"
            v-if="
              (currentSubEvent.type == 'online' ||
              currentSubEvent.type == 'hybrid') && !isTravelEvent
            "
            class="pt-0"
          >
            <div class="text-body-2 font-weight-medium">Event join link</div>
          </v-col>
          <v-col
            class="pt-0"
            cols="7"
            md="7"
            v-if="
              (currentSubEvent.type == 'online' ||
              currentSubEvent.type == 'hybrid') && !isTravelEvent
            "
          >
            <v-text-field
              dense
              outlined
              placeholder="Zoom or Google Meet URL"
              v-model="currentSubEvent.joiningLink"
            />
          </v-col>

          <v-col cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              URL to your event page
              <span class="grey--text">(optional)</span>
            </div>
          </v-col>
          <v-col cols="7" md="7" class="py-0">
            <v-text-field
              dense
              outlined
              v-model="currentSubEvent.eventPageURL"
              placeholder="Add a URL so attendees can access information about your event"
              hint="This URL will also be accessible when your event is promoted within the Pappyon newsfeed."
            />
          </v-col>

          <v-col
            class="pt-0"
            cols="12"
            md="12"
            v-if="
              currentSubEvent.type == 'in-person' ||
              currentSubEvent.type == 'hybrid' ||
              isTravelEvent
            "
          >
            <div class="text-body-2 font-weight-medium">Location</div>
          </v-col>
          <v-col
            cols="7"
            md="7"
            class="py-0"
            v-if="
              currentSubEvent.type == 'in-person' ||
              currentSubEvent.type == 'hybrid' ||
              isTravelEvent
            "
          >
            <v-text-field
              dense
              outlined
              placeholder="e.g. State Library Victoria, 328 Swanston St, Melbourne 3000"
              v-model="currentSubEvent.address"
            />
          </v-col>
          <!-- <v-col cols="6"> </v-col> -->
          <v-col cols="12" md="12" hidden>
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-space-between">
                <!-- { 'cursor-disabled': isEditMode },    :disabled="isEditMode" -->
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                  ]"
                  hide-details
                  v-model="currentSubEvent.hasAskOfferNote"
                  label="Allow attendees to add AskOffer and General Notes"
                  style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    The AskOffer and General Notes sections allow attendees to
                    ask for assistance from fellow attendees and offer their
                    expertise in the field they specialize in, as well as add
                    any notes they would like to share. This option cannot be
                    changed after the link has been created.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              About this sub event
            </div>
          </v-col>
          <v-col class="py-0" cols="7" md="7">
            <v-textarea
              outlined
              placeholder="Description about this sub-event"
              v-model="currentSubEvent.description"
            />
          </v-col>

          <v-col class="pt-0" cols="12" md="12" v-if="!isTravelEvent">
            <div class="text-body-2 font-weight-medium">
              URL to sitemap (optional)
            </div>
          </v-col>

          <v-col cols="7" md="7" class="py-0" v-if="!isTravelEvent">
            <v-text-field
              dense
              outlined
              v-model="currentSubEvent.sitemapURL"
              placeholder="URL to sitemap"
              hint=""
            />
          </v-col>

          <v-col cols="12" md="12">
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-start">
                <!--,    -->
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                    { 'cursor-disabled': isEditMode },
                  ]"
                  hide-details
                  v-model="currentSubEvent.enableChatroom"
                  label="Enable chat room"
                  style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    Enable chat room for all attendees attending the event. Chat
                    room cannot be disabled once event has been created.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <!---End: Sub event details--->

      <!-- <AddEditEventDetails eventCategory="subEvent" /> -->
    </v-row>
  </v-form>
</template>

<script>
// import UploadImages from "../UploadImages";
import AddEditEventDetails from "../AddEditEventDetails";
import { mapGetters } from "vuex";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import AvatarButton from "@/components/AvatarButton";
import {my} from "timeago.js/lib/lang";
import SocialTextFieldTitle from "@/components/MultiConnect/Sponsors/SocialTextFieldTitle.vue";

export default {
  components: {
    SocialTextFieldTitle,
    // UploadImages,
    AddEditEventDetails,
    AddNewImage,
    UploadImageDialog,
    AvatarButton,
  },
  data() {
    return {
      eventId: "",
      subEventId: "",
      isTravelEvent: false,
      unsubscribeEventsSnapshot: null,
      showUploadCoverImageDialog: false,
      requiredRules: [(v) => !!v || "This field is requried"],
      timezoneItems: [],
      range: {
        start: "",
        end: "",
      },
      timeRange: {
        start: "",
        end: "",
      },
      attribute: {
        highlight: {
          start: {
            style: {
              backgroundColor: "#F15E31", //primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
          base: {
            style: {
              backgroundColor: "#FEECE8", // tint
            },
          },
          end: {
            style: {
              backgroundColor: "#F15E31", // primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
        },
      },
      isValid: false,
      isDateTimePickerReadOnly: false,
    };
  },
  created() {
    if (
      this.currentSubEvent.getStatus() == "Active" ||
      this.currentSubEvent.getStatus() == "Past"
    )
      this.isDateTimePickerReadOnly = true;
    if (this.currentEvent.eventCategory === "travel") {
      this.isTravelEvent = true;
    }
    //Set the start and end date-time values
    if (this.isTravelEvent) {
      this.range = this.currentSubEvent.startDateTime;
      this.timeRange.start = this.currentSubEvent.startDateTime;
      this.timeRange.end = this.currentSubEvent.endDateTime;
    } else {
      this.range.start = this.currentSubEvent.startDateTime;
      this.range.end = this.currentSubEvent.endDateTime;
    }

    //Get list of available time zones
    this.timezoneItems = Intl.supportedValuesOf("timeZone");

    console.log(
      "this.currentSubEvent.timezone: ",
      this.currentSubEvent.timezone
    );

    //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.currentSubEvent.timezone) {
      console.log("check defa timezone");
      // this.currentSubEvent.timezone =
      //   Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.currentSubEvent.timezone = this.currentEvent.timezone;
    }
  },
  computed: {
    ...mapGetters(["currentSubEvent", "currentEvent"]),
    minStartDate() {
      return new Date().toISOString().slice(0, 10);
    },
    isEditMode() {
      return !this.currentSubEvent.isCreationInProgress;
    },
    validStartTimeHours() {
      const endTime = this.timeRange.end;
      console.log(endTime);
      const validHours = [];
      if (endTime) {
        const time = endTime.getHours();
        for (let i = 1; i <= time; i++) {
          validHours.push(i);
        }
      } else {
        for (let i = 0; i < 24; i++) {
          validHours.push(i);
        }
      }
      return validHours;
    },
    validEndTimeHours() {
      const startTime = this.timeRange.start;
      const validHours = [];
      if (startTime) {
        const time = startTime.getHours();
        for (let i = time; i < 24; i++) {
          validHours.push(i);
        }
      } else {
        for (let i = 0; i < 24; i++) {
          validHours.push(i);
        }
      }
      return validHours;
    }
  },
  methods: {
    my,
    onStartTimeSwitch() {
      if(this.currentSubEvent.enableStartTime === false) {
        this.currentSubEvent.enableEndTime = false;
        this.currentSubEvent.endDateTime.setHours(23, 59);
        this.timeRange.end.setHours(23, 59);
      }
    },
    onEndTimeSwitch() {
      if (!this.currentSubEvent.enableEndTime) {
        this.timeRange.end.setHours(23, 59);
        this.currentSubEvent.endDateTime.setHours(23, 59);
      }

    },
    async handleCoverImageUploaded(downloadURL) {
      this.currentSubEvent.coverImageURL = downloadURL;
    },
    handleCompressedImageUploaded(compressedImageDownloadURL) {
      this.currentSubEvent.compressedCoverImageURL = compressedImageDownloadURL;
    },
    handleBlur() {
      console.log("This was called");
      if (this.isTravelEvent) {
        this.currentSubEvent.startDateTime = this.range;
        this.currentSubEvent.endDateTime = this.range;
        this.timeRange.start = this.range;
        this.timeRange.end = this.range;
      } else {
        this.currentSubEvent.startDateTime = this.range.start;
        this.currentSubEvent.endDateTime = this.range.end;
      }
      //Start: UNCOMMENT LATER ON
      this.$refs.addEditSubEventDetailsForm.resetValidation();
    },
    onTimeUpdate(isEndTime) {
      if(isEndTime) {
        if (this.currentSubEvent.endDateTime) {
          this.currentSubEvent.endDateTime = this.timeRange.end;
        }
      } else {
        if (this.currentSubEvent.startDateTime) {
          this.currentSubEvent.startDateTime = this.timeRange.start;
        }
      }
    },
    getEventDateTime(inputValue) {
      if (typeof inputValue === 'string') {
        return inputValue;
      } else if (inputValue.start != null && inputValue.end != null)
        return inputValue.start + " to " + inputValue.end;
      return "";
    },
    getEventTime(inputValue) {
      if (inputValue) {
        return inputValue;
      }
      return "";
    },
    getEventActivationAndExpirationDateTime() {
      return (
        "EventConnect link will automatically activate on " +
        this.currentSubEvent.getFormattedEventActivationDateTime() +
        " and expire on " +
        this.currentSubEvent.getFormattedEventExpirationDateTime() +
        " (" +
        this.currentSubEvent.timezone +
        ")"
      );
    },
    validatePage() {
      console.log("validating sub-event details page...");
      let isValid = this.$refs.addEditSubEventDetailsForm.validate();
      return isValid;
    },
  },
};
</script>

<style>
</style>